import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { deployment } from "../../environments/environment";
import { BackendInfo } from "../../../modules/lipidcompass-backend-client/model/backendInfo";

@Injectable({
  providedIn: "root"
})
export class BackendInfoService {
  private http = inject(HttpClient);

  private backendUrl = deployment.gatewayPath;

  getBackendInfo(): Observable<BackendInfo> {
    return this.http.get<BackendInfo>(`${this.backendUrl}/actuator/info`);
  }
}
